const ssnOrArnWarn = (value, allValues, props, fieldName) => {
  const pi = allValues?.personalInformation || {};
  const ssn = (pi.socialSecurityNumber || '').trim();
  const arn = (pi.alienRegistrationNumber || '').trim();
  const isAffordable = props.isAffordable;
  const allowArnForMinors = props.flags?.alienRegNumberMinors ?? false;

  if (!isAffordable) return undefined;

  if (allowArnForMinors) {
    return !ssn && !arn ? 'Required' : undefined;
  }
  return fieldName === 'socialSecurityNumber' && !ssn ? 'Required' : undefined;
};

export const warnSSN = (v, all, props) =>
  ssnOrArnWarn(v, all, props, 'socialSecurityNumber');

export const warnARN = (v, all, props) =>
  ssnOrArnWarn(v, all, props, 'alienRegistrationNumber');

export const warnDOBMinor = (value, allValues, props) => {
  if (!props?.isAffordable) return undefined;
  const dob = (allValues?.personalInformation?.dateOfBirth ?? '')
    .toString()
    .trim();
  return dob ? undefined : 'Required';
};
